/*eslint-disable*/
import {commonApi, check} from '@/common/index'
import {mapActions} from 'vuex'

export default{
  data() {
    return {
      // 优惠按钮
      nameButton: false,
      nameId: '',

      mailButton: false,
      mailId: '',

      bankButton: false,
      bankId: '',

      phoneButton: false,
      phoneId: '',

      appButton: false,
      appId: '',
    }
  },
  watch: {
    complete() { // 监听完成认证，刷新红利信息
      if(this.complete) {
        this.queryBonusBindUserInfoList()
      }
    }
  },
  methods: {
    ...mapActions(['getFirstInfo']),
    // 查询会员绑定优惠
    // 返回list
    // status => 1 可领取  0 已领取
    // type => 1:真实姓名，2=绑定邮箱  3=绑定银行卡  4=绑定手机号   5=绑定app
    async queryBonusBindUserInfoList() {
      let params = {
        UUID: this.UUID
      };
      let data = await commonApi.DEPOSIT.queryBonusBindUserInfoList(params);
      let list = data.data.data;
      if(!list) return;
      this.nameButton = false;
      this.mailButton = false;
      this.bankButton = false;
      this.phoneButton = false;
      this.appButton = false;
      if(list.length>0) {
        list.forEach((item,index) => {
          // type 1:真实姓名，2=绑定邮箱  3=绑定银行卡  4=绑定手机号   5=绑定app
          switch (item.type) {
            case '1':
              this.nameButton = true;
              this.nameId = item.viewOfferId;
              break;
            case '2':
              this.mailButton = true;
              this.mailId = item.viewOfferId;
              break;
            case '3':
              this.bankButton = true;
              this.bankId = item.viewOfferId;
              break;
            case '4':
              this.phoneButton = true;
              this.phoneId = item.viewOfferId;
              break;
            case '5':
              this.appButton = true;
              this.appId = item.viewOfferId;
              break;
          }
        })
      }
    },
    // 认证红利
    applyBonus(str) {
      let params = {
        configId: this[str]
      };
      commonApi.DEPOSIT.applyBonus(params)
        .then(data => {
          if(data.data.code===200) {
            this.$message({
              message: data.data.msg,
              type:'success'
            });
          }else {
            this.$message({
              message: data.data.msg,
              type:'warning'
            });
          }
          this.getFirstInfo();
          this.queryBonusBindUserInfoList()
        })
        .catch(err=>{})
    },
  },
  mounted() {
    this.queryBonusBindUserInfoList()
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/bonus/queryBonusBindUserInfoList.js